import Vue from 'vue'
import Vuex from 'vuex'
import dayjs from 'dayjs'
import { getLocalStorage, getSessionStorage } from "@/utils/myStorage.js";

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		// 接口基地址
		baseUrl: '',
		// 用户信息
        userInfo:  getLocalStorage('userInfo') || getSessionStorage('userInfo') || {},
        // 重定向地址
        directVisitUrl: '',
		// 对话框标签宽度
		labelWidth: "90px",

		// 日期ui组件参数配置
        pickerOptions: {
            firstDayOfWeek: 1,
            shortcuts: [
                {
                    text: dayjs(new Date()).format('YYYY-MM-DD'),
                    onClick(picker) {
                        picker.$emit("pick", new Date());
                    }
                }
            ]
        },
        // 组装工单-图表视图开始时间参数配置
        quickChecked: {
            firstDayOfWeek: 1,
            shortcuts: [
                {
                    text: "本年",
                    onClick(picker) {
                        picker.$emit("pick", `${dayjs().year()}-01-01`);
                    }
                },
                {
                    text: "本季度",
                    onClick(picker) {
                        let month = dayjs().month()+1, newMonth;
                        switch(true) {
                            case(month <= 3):
                                newMonth = "01";
                                break;
                            case(month <= 6):
                                newMonth = "04";
                                break;
                            case(month <= 9):
                                newMonth = "07";
                                break;
                            case(month <= 12):
                                newMonth = "10";
                                break;
                        }
                        picker.$emit("pick", `${dayjs().year()}-${newMonth}-01`);
                    }
                },
                {
                    text: "本月",
                    onClick(picker) {
                        let month = dayjs().month()+1, newMonth;
                        if(month<10) {
                            newMonth = "0" + month
                        } else {
                            newMonth = month
                        }
                        picker.$emit("pick", `${dayjs().year()}-${newMonth}-01`);
                    }
                },
                {
                    text: "最近12个月",
                    onClick(picker) {
                        recentlyMonth(picker, 12)
                    }
                },
                {
                    text: "最近6个月",
                    onClick(picker) {
                        recentlyMonth(picker, 6)
                    }
                },
                {
                    text: "最近3个月",
                    onClick(picker) {
                        recentlyMonth(picker, 3)
                    }
                },
                {
                    text: "最近1个月",
                    onClick(picker) {
                        recentlyMonth(picker, 1)
                    }
                },
                {
                    text: dayjs().format('YYYY-MM-DD'),
                    onClick(picker) {
                        picker.$emit("pick", dayjs().format('YYYY-MM-DD'));
                    }
                }
            ]
        },
	}
})

function recentlyMonth(picker, value) {
    let newDate = dayjs().subtract(value, 'month').format("YYYY-MM-DD");
    picker.$emit("pick", newDate);
}

export default store